import { AccountErrorType, OrderEntryIssueTypeInternational } from '../../../../enums';
export interface IOrderEntrySubtypeInt {
    issueType: OrderEntryIssueTypeInternational;
    accountErrorType?: AccountErrorType;
    errorDescription?: string;
    canIdentifyCartonId?: boolean;
    cartonId?: string;
}
